/* @generated */

// src/assets/ui-icon/fill/star.tsx
import * as React from "react";
var StarFill = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m20.836 9.911-6.105-.887L12 3.491 9.27 9.024l-6.106.887 4.43 4.319-.833 6.163L12 17.442l5.24 2.951-.834-6.164 4.43-4.318Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  StarFill
};
